import React from 'react';

export const OrdersContext = React.createContext();
export const useOrders = () => React.useContext(OrdersContext);

export const OrdersProvider = ({children}) => {

    const [itemsList, setItemsList] = React.useState([
      {
        item_id: "3666565",
        name: "Short Sleeve Round Neck Graphic Printed T-Shirt - Blue",
        sku: "92598293319",
        amount_refunded: "0.0000",
        promo_ids: "613",
        promo_names: "",
        discount_amount: "3.9000",
        item_mrp: "39.0000",
        row_total: 35.1,
        is_virtual: "0",
        product_type: "simple",
        qty_canceled: "0.0000",
        qty_invoiced: "1.0000",
        qty_ordered: "1.0000",
        qty_refunded: "0.0000",
        qty_returned: "0.0000",
        qty_shipped: "1.0000",
        thumbnail: "/a/r/ar60015206-blue-461-760x850_1.jpg",
        brand_name: "Aeropostale",
        status:"Processing"
    },
    {
        item_id: "3666566",
        name: "Short Sleeve Round Neck Graphic Printed T-Shirt - Blue",
        sku: "92598293319",
        amount_refunded: "0.0000",
        promo_ids: "613",
        promo_names: "",
        discount_amount: "3.9000",
        item_mrp: "39.0000",
        row_total: 35.1,
        is_virtual: "0",
        product_type: "simple",
        qty_canceled: "0.0000",
        qty_invoiced: "1.0000",
        qty_ordered: "1.0000",
        qty_refunded: "0.0000",
        qty_returned: "0.0000",
        qty_shipped: "1.0000",
        thumbnail: "/a/r/ar60015206-blue-461-760x850_1.jpg",
        brand_name: "Aeropostale",
        status:"Processing"
      }
    ]);
    
    return (
        <OrdersContext.Provider
          value={{
            itemsState: {
                itemsList,
                setItemsList
            }
          }}>
          {children}
        </OrdersContext.Provider>
      );
}